import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { MyTicketsComponent } from './tickets/my-tickets/my-tickets.component';
import { CreateTicketsComponent } from './tickets/create-tickets/create-tickets.component';
import { OverDueTicketsComponent } from './tickets/over-due-tickets/over-due-tickets.component';
import { UpComingComponent } from './tickets/up-coming/up-coming.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_helpers';
import { AppComponent } from './app.component';
import { RegisterComponent } from './register/register.component';
import { CustomersComponent } from './customers/customers.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { AllUsersComponent } from './all-users/all-users.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { NewCustomersComponent } from './new-customers/new-customers.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { BeakSubscriptionComponent } from './beak-subscription/beak-subscription.component';
import { BeakCustomerComponent } from './beak-subscription/beak-customer/beak-customer.component';



const routes: Routes = [

  { path: '', component: LoginComponent },  
  { path: 'my-tickets', component: MyTicketsComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'customers', component: CustomersComponent ,canActivate: [AuthGuard]},
  { path: 'new-customers', component: NewCustomersComponent ,canActivate: [AuthGuard]},
  { path: 'register', component: RegisterComponent ,canActivate: [AuthGuard]},
  { path: 'subscription', component: SubscriptionComponent ,canActivate: [AuthGuard]},
  { path: 'users', component: AllUsersComponent,canActivate: [AuthGuard] },
  { path: 'customer-detail/:userID', component:CustomerDetailComponent },
  { path: 'user-detail/:userID', component:UserDetailComponent},
  { path: 'beak-subscription', component:BeakSubscriptionComponent, canActivate: [AuthGuard]}, // added route for beak subscription
  // To access the customers licenses
  { path: 'beak-customer/:userID', component: BeakCustomerComponent,}, // Removed authguard  canActivate: [AuthGuard]
  { path: '', loadChildren: () => import('../app/tickets/tickets.module').then(mod => mod.TicketsModule) },
  // otherwise redirect to home
  { path: '**', redirectTo: 'login' } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
